// extracted by mini-css-extract-plugin
module.exports = {"buttonBase":"plain-button_component_buttonBase__Bzyo7","iconBox":"plain-button_component_iconBox__lrYga"};